<div [ngClass]="{'popup-open' : display}" class="popup" (click)="stopPropagation($event)">
    <ng-content></ng-content>
</div>